import React from 'react';
import NotFoundPage from './NotFoundPage';
import ThemeErrorBoundary from '../theme/ThemeErrorBoundary';
import { StyledComponentsIntegration } from '../theme/StyledComponentsIntegration';

/**
 * NotFoundPageWrapper
 * 
 * This component wraps the NotFoundPage component with the StyledComponentsIntegration
 * to ensure that styled-components has access to the theme.
 */
const NotFoundPageWrapper: React.FC = () => {
  return (
    <ThemeErrorBoundary>
      <StyledComponentsIntegration>
        <NotFoundPage />
      </StyledComponentsIntegration>
    </ThemeErrorBoundary>
  );
};

export default NotFoundPageWrapper;